import type { FunctionComponent } from "react";
import type { IconProps } from "@tamagui/helpers-icon";
import { ChevronRight as ChevronRightIcon } from "@tamagui/lucide-icons";
import { Paragraph, Spinner, Square, XStack } from "@medbillai/ui";
export type UploadOptionCardProps = {
  icon: FunctionComponent<IconProps>;
  title: string;
  isLoading: boolean;
  onPress?: () => void;
};
export const UploadOptionCard = ({
  icon: Icon,
  title,
  isLoading,
  onPress
}: UploadOptionCardProps) => {
  return <XStack backgroundColor="$surface2" borderColor="$borderDefault" borderWidth="$border2" borderRadius="$br3" paddingLeft="$sp1" paddingRight="$sp2" paddingVertical="$sp1" alignItems="center" gap="$sp2" hoverStyle={{
    backgroundColor: "$backgroundHover"
  }} pressStyle={{
    backgroundColor: "$backgroundPress"
  }} cursor={onPress ? "pointer" : undefined} onPress={onPress} userSelect="none" data-sentry-element="XStack" data-sentry-component="UploadOptionCard" data-sentry-source-file="UploadOptionCard.tsx">
      <Square justifyContent="center" alignItems="center" size={56} borderRadius="$br2" backgroundColor="$surface0" data-sentry-element="Square" data-sentry-source-file="UploadOptionCard.tsx">
        {isLoading ? <Spinner transition="quick" color="$color" enterStyle={{
        opacity: 0
      }} exitStyle={{
        opacity: 0
      }} /> : <Icon color="$iconDefault" size="$iconLarge" strokeWidth={2} />}
      </Square>
      <Paragraph flex={1} data-sentry-element="Paragraph" data-sentry-source-file="UploadOptionCard.tsx">{title}</Paragraph>
      <ChevronRightIcon color="$iconSubtle" size="$iconLarge" strokeWidth={2} data-sentry-element="ChevronRightIcon" data-sentry-source-file="UploadOptionCard.tsx" />
    </XStack>;
};